import { memo } from "react";
import type { PopupProps } from "../popup";
import { Popup } from "../popup";

export interface LocationPopupProps
  extends Omit<PopupProps, "children" | "style"> {
  name: string;
  description: string;
}

export const LocationPopup = memo(function MemoisedLocationPopup({
  longitude,
  latitude,
  name,
  description,
}: LocationPopupProps) {
  return (
    <Popup longitude={longitude} latitude={latitude} focusAfterOpen={false}>
      <div className="relative flex max-w-[200px] items-center gap-4 rounded-2xl bg-white p-3 pr-6 font-sans shadow-lg">
        <div className="flex flex-col gap-0.5 overflow-hidden">
          <p className="truncate font-header text-base font-medium text-grey-900">
            {name}
          </p>
          <p className="truncate text-sm text-grey-500">{description}</p>
        </div>
      </div>
    </Popup>
  );
});
